import moment from 'moment';

export var IRPF_FILTERS_KEY = 'irpf';

export var IRPF_STATUS_KEYS = ['concluido', 'emProcesso', 'pendente', 'anoAnterior'];

// Defaults depend on "today" (current year), so they are built at mount.
// The year is kept as a number (JSON-serializable), never as a moment.
export var getDefaultIrpfFilters = function() {
  return {
    year: moment().year(),
    showActive: true,
    statusFilter: null,
    search: '',
  };
};

// Year as a number, whatever the source (number, '2025', moment).
export var toIrpfYear = function(value, fallback) {
  if (value && typeof value.year === 'function') return value.year();
  var n = parseInt(value, 10);
  return isNaN(n) ? fallback : n;
};

// Guards against a stale/garbled saved entry before it reaches the screen.
export var normalizeIrpfFilters = function(filters, defaults) {
  var f = filters || {};
  var statusFilter = IRPF_STATUS_KEYS.indexOf(f.statusFilter) >= 0 ? f.statusFilter : null;
  return {
    year: toIrpfYear(f.year, defaults.year),
    showActive: f.showActive !== false,
    statusFilter: statusFilter,
    search: typeof f.search === 'string' ? f.search : '',
  };
};

// The redux store (and DrawerIRPF) keep the year as a moment.
export var irpfYearToMoment = function(year) {
  return moment().year(year);
};

// Badge: only what differs from the defaults.
export var countActiveIrpfFilters = function(filters, defaults) {
  return (filters.year !== defaults.year ? 1 : 0) +
    (filters.showActive !== defaults.showActive ? 1 : 0) +
    (filters.statusFilter ? 1 : 0) +
    (filters.search ? 1 : 0);
};
